module.exports = __webpack_public_path__ + "icons/original/small/small-c6.3a75bba0385dcc7f6e7074d7873ff81e.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-c6.png
// module id = 20Ho
// module chunks = app